/* eslint-disable no-multi-spaces */
import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Button,
  Alert,
  Pagination,
} from 'react-bootstrap'
import { newSection, setExpirationDate, updatePageNum } from '../actions'
import ActionButtonSection from './ActionButtonSection'
import ButterToast, { Cinnamon } from 'butter-toast'
import { MEModal } from '../../components'
import { METable } from '@CommonComponents'

class SectionsTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      modalOpen: false,
      newSectionName: '',
      timeOffset: '',
      offsetAlert: false,
    }

    this.toggleModal = this.toggleModal.bind(this)
    this.handleNewSectionNameChange = this.handleNewSectionNameChange.bind(this)
    this.handleTimeOffsetChange = this.handleTimeOffsetChange.bind(this)
    this.handleFormSubmit = this.handleFormSubmit.bind(this)
  }

  itemIdxDisplayer(perPage, pageNum, pageItemCount, totalItemCount) {
    let baseIdx = perPage * (pageNum - 1)
    let startIdx = totalItemCount > 0 ? baseIdx + 1 : baseIdx
    return ` ${startIdx} - ${baseIdx + pageItemCount} of ${totalItemCount} `
  }

  toggleModal() {
    this.setState({
      modalOpen: !this.state.modalOpen,
      newSectionName: '',
      timeOffset: '',
    })
  }

  handleNewSectionNameChange(e) {
    this.setState({ newSectionName: e.target.value })
    this.getSecNameValidationState()
  }

  getSecNameValidationState() {
    if (this.cleanSecNameField()) {
      return 'error'
    }
  }

  cleanSecNameField() {
    if (!this.state.newSectionName) {
      return true
    }
  }

  handleTimeOffsetChange(e) {
    this.setState({ timeOffset: e.target.value })
    this.getOffsetValidationState()
  }

  getOffsetValidationState() {
    if (this.cleanOffsetField()) {
      return 'error'
    }
  }

  cleanOffsetField() {
    if (
      this.state.timeOffset.length > 0 &&
      !/\d{1,2}:\d{2}/.test(this.state.timeOffset)
    ) {
      return true
    }
  }

  async handleFormSubmit() {
    let response = await this.props.newSection(
      this.state.newSectionName,
      this.state.timeOffset
    )
    this.toggleModal()
    if (response.status === 200) {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Section Added"
            content="Successfully added new section."
            scheme={Cinnamon.Crisp.SCHEME_GREY}
          />
        ),
      })
    } else {
      ButterToast.raise({
        content: (
          <Cinnamon.Crunch
            title="Error"
            content={response.data.error}
            scheme={Cinnamon.Crisp.SCHEME_RED}
          />
        ),
        sticky: true,
      })
    }
  }

  tableOptions = {
    sizePerPage: 20,
    totalSize: this.props.rowData.length,
    hideSizePerPage: true,
  }

  tableColumns = [
    'Section Name',
    'Time Offset',
    'Signup URL',
    'Signup Expiration',
    'Actions',
  ]

  buildTableData = sectionData => {
    let cellRows = []
    sectionData.map((row, i) =>
      cellRows.push([
        row.secName,
        row.offset,
        <a href={row.signupUrl} key={i}>
          {row.signupText}
        </a>,
        row.expiration,
        <ActionButtonSection
          section={row.id}
          sectionName={row.secName}
          key={i}
        />,
      ])
    )
    return cellRows
  }

  render() {
    const alert = (
      <Alert bsStyle="danger">
        Please enter the time offset in the correct format.
      </Alert>
    )
    return (
      <Fragment>
        <div className="card-myed">
          <div className="pull-right">
            <a
              className="btn btn-default btn-myed btn-default-myed"
              onClick={this.toggleModal}
            >
              <div className="fal fa-plus fa-fw mr-2" /> Add Section
            </a>
          </div>
          <h3>Sections</h3>
          <p>
            Sections
            {this.itemIdxDisplayer(
              this.props.pageLimit,
              this.props.currentSectionPage,
              this.props.rowData.length,
              this.props.sectionCount
            )}
            shown
          </p>
          <div className="row p-3">
            <METable
              columns={this.tableColumns}
              data={this.buildTableData(this.props.rowData)}
              columnCss={{'Actions': 'text-center'}}
            />
            <div className="text-center">
              <Pagination
                prev={<span className="text-dark">{'<'}</span>}
                next={<span className="text-dark">{'>'}</span>}
                first={<span className="text-dark">{'<<'}</span>}
                last={<span className="text-dark">{'>>'}</span>}
                maxButtons={5}
                items={Math.ceil(
                  this.props.sectionCount / this.props.pageLimit
                )}
                activePage={this.props.page}
                onSelect={page =>
                  this.props.updatePageNum({
                    page: page,
                    table: this.props.tableName,
                  })
                }
              />
            </div>
          </div>
        </div>
        <MEModal
          show={this.state.modalOpen}
          close={this.toggleModal}
          title="Add Section"
        >
          <form onSubmit={e => e.preventDefault()}>
            {this.state.offsetAlert ? alert : ''}
            <FormGroup
              controlId="formSectionName"
              validationState={this.getSecNameValidationState()}
            >
              <ControlLabel>New Section Name (required)</ControlLabel>
              <FormControl
                type="text"
                value={this.state.newSectionName}
                onChange={this.handleNewSectionNameChange}
              />
            </FormGroup>
            <FormGroup
              controlId="formTimeOffset"
              validationState={this.getOffsetValidationState()}
            >
              <ControlLabel>Time Offset</ControlLabel>
              <FormControl
                type="text"
                value={this.state.timeOffset}
                placeholder="0:00"
                onChange={this.handleTimeOffsetChange}
              />
              <HelpBlock>
                Specify the offset for this section in H:MM. All due dates will
                be shifted with this offset when displayed to students.
              </HelpBlock>
            </FormGroup>
            <Button
              type="button"
              className="btn-myed btn-primary-myed"
              bsStyle="primary"
              onClick={this.handleFormSubmit}
            >
              Save
            </Button>
          </form>
        </MEModal>
      </Fragment>
    )
  }
}

SectionsTable.propTypes = {
  rowData: PropTypes.array,
  newSection: PropTypes.func,
  sectionCount: PropTypes.number,
  currentSectionPage: PropTypes.number,
  updatePageNum: PropTypes.func,
  pageLimit: PropTypes.number,
  tableName: PropTypes.string,
  page: PropTypes.number,
  sendExpirationDate: PropTypes.func,
}

const mapStateToProps = state => {
  return {
    rowData: state.sectionRowData,
    sectionCount: state.sectionCount,
    pageLimit: state.sectionPageLimit,
    currentSectionPage: state.currentSectionPage,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    newSection: (name, offset) => {
      let response = dispatch(newSection(name, offset))
      return response
    },
    sendExpirationDate: sectionData => {
      let response = dispatch(setExpirationDate(sectionData))
      return response
    },
    updatePageNum: (pageNum, tableName) =>
      dispatch(updatePageNum(pageNum, tableName)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SectionsTable)
